var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 99,
    viewBox: "0 0 190 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.376 24.603C113.989 7.14784 131.268 -2.36133 147.522 1.44775C158.783 4.08655 167.644 12.6696 173.205 24.7563C180.816 18.3498 189.54 15.4199 197.89 17.3765C216.011 21.6232 225.497 47.2719 219.078 74.6646C212.659 102.057 192.765 120.821 174.644 116.575C170.903 115.698 167.532 113.908 164.591 111.38C151.809 131.869 132.9 143.505 115.205 139.359C106.542 137.329 99.2988 131.781 93.8857 123.826C83.3912 135.257 70.396 141.027 58.0645 138.137C47.3562 135.628 39.0999 127.046 34.2803 115.072C26.0807 123.158 16.2594 127.094 6.90918 124.903C-11.212 120.656 -20.6984 95.0076 -14.2793 67.6147C-7.86014 40.2219 12.0341 21.4581 30.1553 25.7046C36.4062 27.1695 41.6289 31.1817 45.5264 36.9331C56.7193 21.2168 72.1611 12.6177 86.6807 16.02C92.3017 17.3372 97.2479 20.3273 101.376 24.603Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.8c377e0fa5a6fc17d022626cef65fed0.svg";
export { ForwardRef as ReactComponent };